<template>
  <v-container class="py-5">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card outlined>
          <v-card-title>
            <h2 class="text-h6">Ajouter un niveau de service</h2>
          </v-card-title>
          <v-form @submit.prevent="submitForm" ref="form">
            <v-card-text>
              <v-select
                v-model.number="form.service"
                :items="serviceOptions"
                item-text="name"
                item-value="id"
                label="Service"
                outlined
                dense
                required
                return-object="false"
                :disabled="!!serviceId"
              ></v-select>
              <v-select v-model="form.level" :items="levelChoices" label="Niveau" outlined dense required></v-select>
              <v-text-field
                v-model.number="form.nb_standard_meals"
                label="Repas standards"
                type="number"
                outlined
                dense
                required
              ></v-text-field>
              <v-text-field
                v-model.number="form.nb_no_pork_meals"
                label="Repas sans porc"
                type="number"
                outlined
                dense
                required
              ></v-text-field>
              <v-text-field
                v-model.number="form.nb_vegetarian_meals"
                label="Repas végétariens"
                type="number"
                outlined
                dense
                required
              ></v-text-field>
              <v-text-field
                v-model.number="form.nb_animators"
                label="Animateurs"
                type="number"
                outlined
                dense
              ></v-text-field>
              <v-text-field v-model.number="form.nb_trays" label="Plateaux" type="number" outlined dense></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" type="submit" :disabled="!form.service">Ajouter</v-btn>
              <router-link :to="{ name: 'ServiceList' }">
                <v-btn text>Annuler</v-btn>
              </router-link>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ServiceLevelForm",
  props: {},
  data() {
    return {
      form: {
        service: null,
        level: "",
        nb_standard_meals: 0,
        nb_no_pork_meals: 0,
        nb_vegetarian_meals: 0,
        nb_animators: 0,
        nb_trays: 0,
      },
      serviceOptions: [],
      levelChoices: [
        { value: "MATERNELLE", text: "Maternelle" },
        { value: "ELEMENTAIRE", text: "Élémentaire" },
        { value: "COLLEGE", text: "Collège" },
        { value: "LYCEE", text: "Lycée" },
        { value: "ENSEIGNANT", text: "Enseignant" },
      ],
      serviceId: null,
    }
  },
  methods: {
    async fetchServices() {
      try {
        const response = await this.$store.dispatch("fetchServices")
        this.serviceOptions = response
        // If serviceId is present, pre-select and disable the service select
        if (this.serviceId && Array.isArray(response)) {
          const found = response.find((s) => String(s.id) === String(this.serviceId))
          if (found) {
            this.form.service = found
          }
        }
      } catch (e) {
        this.serviceOptions = []
      }
    },
    async submitForm() {
      try {
        if (!this.form.service) return
        const payload = {
          ...this.form,
          service: typeof this.form.service === "object" ? Number(this.form.service.id) : Number(this.form.service),
          level: typeof this.form.level === "object" ? this.form.level.value : this.form.level,
        }
        await this.$store.dispatch("createServiceLevel", { payload })
        this.$router.push({ name: "ServiceList" })
      } catch (e) {
        // Optionally handle error (e.g., show notification)
      }
    },
  },
  mounted() {
    // Get serviceId from route params if present
    if (this.$route && this.$route.params && this.$route.params.serviceId) {
      this.serviceId = this.$route.params.serviceId
    }
    this.fetchServices()
  },
}
</script>
